"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddGranteeSelect = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var debounce_promise_1 = tslib_1.__importDefault(require("debounce-promise"));
var react_intl_1 = require("react-intl");
var async_1 = tslib_1.__importDefault(require("react-select/async"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var sdk_model_1 = require("@gooddata/sdk-model");
var types_1 = require("./types");
var AsyncSelectComponents_1 = require("./AsyncSelectComponents");
var loadGranteeOptionsPromise_1 = require("./backend/loadGranteeOptionsPromise");
var SEARCH_INTERVAL = 400;
/**
 * @internal
 */
exports.AddGranteeSelect = function (props) {
    var appliedGrantees = props.appliedGrantees, currentUserRef = props.currentUserRef, onSelectGrantee = props.onSelectGrantee;
    var backend = sdk_ui_1.useBackendStrict();
    var workspace = sdk_ui_1.useWorkspaceStrict();
    var intl = react_intl_1.useIntl();
    var selectRef = react_1.useRef(null);
    react_1.useEffect(function () {
        selectRef.current.focus();
    }, []);
    var onSelect = react_1.useCallback(function (value) {
        var grantee = value.value;
        if (types_1.isGranteeItem(grantee)) {
            onSelectGrantee(grantee);
        }
    }, [onSelectGrantee]);
    var noOptionsMessage = react_1.useMemo(function () { return function () {
        return intl.formatMessage({
            id: "shareDialog.share.grantee.add.search.no.matching.items",
        });
    }; }, []);
    var loadOptions = react_1.useMemo(function () {
        return debounce_promise_1.default(loadGranteeOptionsPromise_1.loadGranteeOptionsPromise(currentUserRef, appliedGrantees, backend, workspace, intl), SEARCH_INTERVAL, {
            leading: true,
        });
    }, [backend, workspace, intl, appliedGrantees]);
    var onKeyDownCallback = react_1.useCallback(function (e) {
        var target = e.target;
        // react-select has default behavior on space and tab key  - open menu / select first option etc.
        // We need disable this behavior for space key by set e.preventDefault when input is empty and for tab key completely
        //space
        if (e.keyCode === 32 && !target.value) {
            e.preventDefault();
        }
        // tab
        if (e.keyCode === 9) {
            e.preventDefault();
        }
    }, []);
    var filterOption = function (option) {
        var grantee = option.value;
        if (types_1.isGranteeItem(grantee)) {
            return !appliedGrantees.some(function (g) {
                return sdk_model_1.areObjRefsEqual(g.id, grantee.id);
            });
        }
        return true;
    };
    return (react_1.default.createElement("div", { className: "gd-share-dialog-content-select" },
        react_1.default.createElement(async_1.default, { ref: selectRef, defaultMenuIsOpen: true, classNamePrefix: "gd-share-dialog", components: {
                DropdownIndicator: AsyncSelectComponents_1.EmptyRenderer,
                IndicatorSeparator: AsyncSelectComponents_1.EmptyRenderer,
                Input: AsyncSelectComponents_1.InputRendered,
                Option: AsyncSelectComponents_1.OptionRenderer,
                GroupHeading: AsyncSelectComponents_1.GroupHeadingRenderer,
                LoadingMessage: AsyncSelectComponents_1.LoadingMessageRenderer,
                LoadingIndicator: AsyncSelectComponents_1.EmptyRenderer,
                MenuList: AsyncSelectComponents_1.MenuListRendered,
                NoOptionsMessage: AsyncSelectComponents_1.NoOptionsMessageRenderer,
            }, loadOptions: loadOptions, defaultOptions: true, placeholder: intl.formatMessage({
                id: "shareDialog.share.grantee.add.search.placeholder",
            }), onKeyDown: onKeyDownCallback, noOptionsMessage: noOptionsMessage, onChange: onSelect, value: null, filterOption: filterOption })));
};
//# sourceMappingURL=AddGranteeSelect.js.map